export const otpDescription =
  "Enter the One-Time Password (OTP) sent to your registered email address to verify your account.";
